import * as React from "react";
import Collapse from "@mui/material/Collapse";
import { grey } from "@mui/material/colors";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddAtsWorkSpaceAction } from "../../../../store/ATS/SwitchWorkspace/Action";
import history from "../../../../history";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { GetWorkspaceAction } from "../../../../store/Signin/Action";
import { GET_WORKSPACE_ERROR } from "../../../../store/Signin/ActionTypes";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import { getDomain } from "../../Base/helper/baseFunctions";

export default function AtsMenu({
  userInfoData,
  setAtsManageCollapse,
  atsManageCollapse,
  atsCollapse,
  atsSubMenu,
  setAtsCollapse,
  atsReportCollapse,
  setReportCollapse,
  atsReportMenu,
  open,
  sideBarData,
  selectedMenu,
  handleMenuClick,
  theme,
  isMobile,
  userData,
}) {
  let AtsUser =
    userInfoData?.is_ats_user ??
    sessionStorage.getItem("is_ats_user") === "true";
  let CoreHRUser =
    userInfoData?.is_corehr_user ??
    sessionStorage.getItem("is_corehr_user") === "true";

  const dispatch = useDispatch();
  const { allowedWokspaceData } = useSelector((state) => state.SignInReducer);
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );

  useEffect(() => {
    if (userData && allowedWokspaceData?.length === 0) {
      const email =
        AtsUser && !CoreHRUser ? userData.email_id : userData.office_email;
      dispatch(GetWorkspaceAction({ email }));
    }
  }, []);

  const atsManageAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Manage"
  );

  const atsReportsAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Reports"
  );

  const atsInvoiceAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Invoice"
  );

  const atsOnboardingAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Employees Onboarding"
  );

  const storeWorkSpace = (item) => {
    if (userData?.domain !== item.domainname) {
      sessionStorage.setItem("selectedMenu", "switchworkspace");
      dispatch(AddAtsWorkSpaceAction({ domain: item }));
      dispatch({ type: GET_WORKSPACE_ERROR });
      history.push(`/ats/switchworkspace`);
    }
  };

  return (
    <React.Fragment key="ats-menu">
      <ListItem
        disablePadding
        sx={{ display: "block", fontSize: "12px", marginTop: "2px" }}
      >
        <ListItemButton
          onClick={() => setAtsCollapse()}
          disableRipple
          selected={atsCollapse}
          sx={{
            "&.Mui-selected:hover": {
              backgroundColor: "rgb(254 255 187 / 48%)",
            },
            ":hover": { backgroundColor: "rgb(254 255 187 / 48%)" },
            borderRadius: "8px",
            fontWeight: 600,
            minHeight: 44,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "flex-start" : "center",
            gap: open ? 2 : 0,
            padding: open ? "8px 12px" : "8px",
            transition: "all 0.3s ease",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
            }}
          >
            <span
              style={{
                color: atsCollapse
                  ? theme?.palette?.primary?.main
                  : theme.palette.mode === "dark"
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary,
                transition: "color 0.3s ease",
              }}
            >
              <ContentPasteSearchIcon fontSize="small" />
            </span>
          </Box>
          {open && (
            <ListItemText
              primaryTypographyProps={{
                variant: "body2",
                fontWeight: atsCollapse ? 600 : 550,
                fontSize: "0.8rem",
                color: atsCollapse ? "primary" : grey[600],
              }}
              primary="ATS Workspaces"
              sx={{ margin: 0 }}
            />
          )}
          {open && (atsCollapse ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
      </ListItem>
      <Collapse in={atsCollapse} timeout="auto" unmountOnExit>
        <ListItem
          disablePadding
          sx={{ display: "block", fontSize: "12px", pl: 0, pt: 1, pb: 1 }}
        >
          <List sx={{ padding: "0px" }}>
            {allowedWokspaceData?.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <>
                    <ListItemButton
                      sx={{
                        "&.Mui-selected:hover": {
                          backgroundColor: "rgb(254 255 187 / 48%)",
                        },
                        ":hover": { backgroundColor: "rgb(254 255 187 / 48%)" },
                        borderRadius: "8px",
                        fontWeight: 600,
                        minHeight: 44,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        gap: open ? 2 : 0,
                        padding: open ? "8px 12px" : "8px",
                        transition: "all 0.3s ease",
                        marginLeft: `${isMobile ? "-4px" : ""}`,
                      }}
                      onClick={() => {
                        storeWorkSpace(item);
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "24px",
                          height: "24px",
                        }}
                      >
                        <span
                          style={{
                            color:
                              userData?.domain === item.domainname
                                ? theme?.palette?.primary?.main
                                : theme.palette.mode === "dark"
                                ? theme.palette.text.primary
                                : theme.palette.text.secondary,
                            transition: "color 0.3s ease",
                          }}
                        >
                          {open ? (
                            userData?.domain === item.domainname ? (
                              <ArrowDropDownIcon />
                            ) : (
                              <ArrowRightIcon />
                            )
                          ) : (
                            <HomeOutlinedIcon />
                          )}
                        </span>
                      </Box>
                      {open && (
                        <ListItemText
                          primaryTypographyProps={{
                            variant: "body2",
                            fontWeight:
                              userData?.domain === item.domainname ? 600 : 550,
                            fontSize: "0.8rem",
                            color:
                              userData?.domain === item.domainname
                                ? "primary"
                                : grey[600],
                          }}
                          primary={item?.domainname}
                          sx={{ margin: 0 }}
                        />
                      )}
                    </ListItemButton>
                    <Collapse
                      in={userData?.domain === item.domainname}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List sx={{ padding: "0px" }}>
                        {sideBarData.map((res, i) => {
                          return (
                            <Link key={i} to={res?.route}>
                              {/* Tour step1 & Tour step 2 */}
                              {res?.show && (
                                <ListItem
                                  disablePadding
                                  data-testid={
                                    res?.label === "Dashboard"
                                      ? "dashboard"
                                      : res?.label === "Add Users"
                                      ? "add-users"
                                      : ""
                                  }
                                  sx={{
                                    display: "block",
                                    fontSize: "12px",
                                    marginLeft: `${isMobile ? "-4px" : ""}`,
                                    pl: 0,
                                  }}
                                  onClick={(e) =>
                                    handleMenuClick(res?.label, res?.route)
                                  }
                                >
                                  <ListItemButton
                                    selected={selectedMenu === res?.label}
                                    sx={{
                                      "&.Mui-selected": {
                                        backgroundColor:
                                          theme?.palette?.primary?.main + "20",
                                      },
                                      "&.Mui-selected:hover": {
                                        backgroundColor:
                                          "rgb(254 255 187 / 48%)",
                                      },
                                      ":hover": {
                                        backgroundColor:
                                          "rgb(254 255 187 / 48%)",
                                      },
                                      borderRadius: "8px",
                                      fontWeight: 600,
                                      minHeight: 44,
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: open
                                        ? "flex-start"
                                        : "center",
                                      gap: open ? 2 : 0,
                                      padding: open ? "8px 12px" : "8px",
                                      transition: "all 0.3s ease",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "24px",
                                        height: "24px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color:
                                            selectedMenu === res?.label
                                              ? theme?.palette?.primary?.main
                                              : theme.palette.mode === "dark"
                                              ? theme.palette.text.primary
                                              : theme.palette.text.secondary,
                                          transition: "color 0.3s ease",
                                        }}
                                      >
                                        {res?.icon}
                                      </span>
                                    </Box>
                                    {open && (
                                      <ListItemText
                                        primaryTypographyProps={{
                                          variant: "body2",
                                          fontWeight:
                                            selectedMenu === res?.label
                                              ? 600
                                              : 550,
                                          fontSize: "0.8rem",
                                          color:
                                            selectedMenu === res?.label
                                              ? "primary"
                                              : grey[600],
                                        }}
                                        primary={res?.label}
                                        sx={{ margin: 0 }}
                                      />
                                    )}
                                  </ListItemButton>
                                </ListItem>
                              )}
                            </Link>
                          );
                        })}
                      </List>
                      {/* Tour-step_3 */}
                      {atsManageAccess && (
                        <ListItem
                          disablePadding
                          sx={{ display: "block", fontSize: "12px", pl: 0 }}
                        >
                          <ListItemButton
                            sx={{
                              "&.Mui-selected:hover": {
                                backgroundColor: "rgb(254 255 187 / 48%)",
                              },
                              ":hover": {
                                backgroundColor: "rgb(254 255 187 / 48%)",
                              },
                              borderRadius: "8px",
                              fontWeight: 600,
                              minHeight: 44,
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: open ? "flex-start" : "center",
                              gap: open ? 2 : 0,
                              padding: open ? "8px 12px" : "8px",
                              transition: "all 0.3s ease",
                            }}
                            onClick={() => setAtsManageCollapse()}
                            disableRipple
                            selected={atsManageCollapse}
                            data-testid="manage-recruiter"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                              }}
                            >
                              <span
                                style={{
                                  color: atsManageCollapse
                                    ? theme?.palette?.primary?.main
                                    : theme.palette.mode === "dark"
                                    ? theme.palette.text.primary
                                    : theme.palette.text.secondary,
                                  transition: "color 0.3s ease",
                                }}
                              >
                                <ManageAccountsIcon fontSize="small" />
                              </span>
                            </Box>
                            {open && (
                              <ListItemText
                                primaryTypographyProps={{
                                  variant: "body2",
                                  fontWeight: atsManageCollapse ? 600 : 550,
                                  fontSize: "0.8rem",
                                  color: atsManageCollapse
                                    ? "primary"
                                    : grey[600],
                                }}
                                primary="Manage"
                                sx={{ margin: 0 }}
                              />
                            )}
                            {open &&
                              (atsManageCollapse ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              ))}
                          </ListItemButton>
                        </ListItem>
                      )}
                      <Collapse
                        in={atsManageCollapse}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List sx={{ padding: "0px" }}>
                          {atsSubMenu.map((res, i) => {
                            return (
                              <Tooltip
                                key={i}
                                title={res.tooltip}
                                placement="right-end"
                              >
                                <Link key={i} to={res?.route}>
                                  {/* Tour step_3&4 */}
                                  {res?.show && (
                                    <ListItem
                                      disablePadding
                                      data-testid={
                                        res?.label === "Client"
                                          ? "manage-company"
                                          : res?.label === "Job"
                                          ? "manage-job"
                                          : ""
                                      }
                                      sx={{
                                        display: "block",
                                        fontSize: "12px",
                                        marginLeft: `${isMobile ? "-4px" : ""}`,
                                        pl: 0,
                                      }}
                                      onClick={(e) =>
                                        handleMenuClick(res?.label, res?.route)
                                      }
                                    >
                                      <ListItemButton
                                        key={i}
                                        sx={{
                                          "&.Mui-selected": {
                                            backgroundColor:
                                              theme?.palette?.primary?.main +
                                              "20",
                                          },
                                          "&.Mui-selected:hover": {
                                            backgroundColor:
                                              "rgb(254 255 187 / 48%)",
                                          },
                                          ":hover": {
                                            backgroundColor:
                                              "rgb(254 255 187 / 48%)",
                                          },
                                          borderRadius: "8px",
                                          fontWeight: 600,
                                          minHeight: 44,
                                          width: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: open
                                            ? "flex-start"
                                            : "center",
                                          gap: open ? 2 : 0,
                                          padding: open ? "8px 12px" : "8px",
                                          transition: "all 0.3s ease",
                                        }}
                                        selected={selectedMenu === res?.label}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "24px",
                                            height: "24px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color:
                                                selectedMenu === res?.label
                                                  ? theme?.palette?.primary
                                                      ?.main
                                                  : theme.palette.mode ===
                                                    "dark"
                                                  ? theme.palette.text.primary
                                                  : theme.palette.text
                                                      .secondary,
                                              transition: "color 0.3s ease",
                                            }}
                                          >
                                            {res?.icon}
                                          </span>
                                        </Box>
                                        {open && (
                                          <ListItemText
                                            key={i}
                                            primaryTypographyProps={{
                                              variant: "body2",
                                              fontWeight:
                                                selectedMenu === res?.label
                                                  ? 600
                                                  : 550,
                                              fontSize: "0.8rem",
                                              color:
                                                selectedMenu === res?.label
                                                  ? "primary"
                                                  : grey[600],
                                            }}
                                            primary={res?.label}
                                            sx={{ margin: 0 }}
                                          />
                                        )}
                                      </ListItemButton>
                                    </ListItem>
                                  )}
                                </Link>
                              </Tooltip>
                            );
                          })}
                        </List>
                      </Collapse>
                      {atsReportsAccess && (
                        <>
                          <ListItem
                            disablePadding
                            sx={{ display: "block", fontSize: "12px", pl: 0 }}
                          >
                            <ListItemButton
                              key={"report-button"}
                              sx={{
                                "&.Mui-selected:hover": {
                                  backgroundColor: "rgb(254 255 187 / 48%)",
                                },
                                ":hover": {
                                  backgroundColor: "rgb(254 255 187 / 48%)",
                                },
                                borderRadius: "8px",
                                fontWeight: 600,
                                minHeight: 44,
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: open ? "flex-start" : "center",
                                gap: open ? 2 : 0,
                                padding: open ? "8px 12px" : "8px",
                                transition: "all 0.3s ease",
                              }}
                              onClick={() => setReportCollapse()}
                              disableRipple
                              selected={atsReportCollapse}
                              data-testid="manage-reports"
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                }}
                              >
                                <span
                                  style={{
                                    color: atsReportCollapse
                                      ? theme?.palette?.primary?.main
                                      : theme.palette.mode === "dark"
                                      ? theme.palette.text.primary
                                      : theme.palette.text.secondary,
                                    transition: "color 0.3s ease",
                                  }}
                                >
                                  <AssessmentIcon fontSize="small" />
                                </span>
                              </Box>
                              {open && (
                                <ListItemText
                                  key={"report-text"}
                                  primaryTypographyProps={{
                                    variant: "body2",
                                    fontWeight: atsReportCollapse ? 600 : 550,
                                    fontSize: "0.8rem",
                                    color: atsReportCollapse
                                      ? "primary"
                                      : grey[600],
                                  }}
                                  primary="Reports"
                                  sx={{ margin: 0 }}
                                />
                              )}
                              {open &&
                                (atsReportCollapse ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                ))}
                            </ListItemButton>
                          </ListItem>
                          <Collapse
                            in={atsReportCollapse}
                            timeout="auto"
                            unmountOnExit
                          >
                            {atsReportMenu.map((res, i) => {
                              return (
                                <Tooltip
                                  key={i}
                                  title={res?.tooltip}
                                  placement="right-end"
                                >
                                  <Link key={i} to={res?.route}>
                                    <List sx={{ padding: "0px" }}>
                                      {res?.show && (
                                        <ListItem
                                          disablePadding
                                          data-testid="Reports"
                                          sx={{
                                            display: "block",
                                            fontSize: "12px",
                                            marginLeft: `${
                                              isMobile ? "-4px" : ""
                                            }`,
                                            pl: 0,
                                          }}
                                          onClick={(e) =>
                                            handleMenuClick(
                                              res?.label,
                                              res?.route
                                            )
                                          }
                                        >
                                          <ListItemButton
                                            key={"reports-button"}
                                            selected={
                                              selectedMenu === res?.label
                                            }
                                            sx={{
                                              "&.Mui-selected": {
                                                backgroundColor:
                                                  theme?.palette?.primary
                                                    ?.main + "20",
                                              },
                                              "&.Mui-selected:hover": {
                                                backgroundColor:
                                                  "rgb(254 255 187 / 48%)",
                                              },
                                              ":hover": {
                                                backgroundColor:
                                                  "rgb(254 255 187 / 48%)",
                                              },
                                              borderRadius: "8px",
                                              fontWeight: 600,
                                              minHeight: 44,
                                              width: "100%",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: open
                                                ? "flex-start"
                                                : "center",
                                              gap: open ? 2 : 0,
                                              padding: open
                                                ? "8px 12px"
                                                : "8px",
                                              transition: "all 0.3s ease",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "24px",
                                                height: "24px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color:
                                                    selectedMenu === res?.label
                                                      ? theme?.palette?.primary
                                                          ?.main
                                                      : theme.palette.mode ===
                                                        "dark"
                                                      ? theme.palette.text
                                                          .primary
                                                      : theme.palette.text
                                                          .secondary,
                                                  transition: "color 0.3s ease",
                                                }}
                                              >
                                                {res?.icon}
                                              </span>
                                            </Box>
                                            {open && (
                                              <ListItemText
                                                key={"reports-text"}
                                                primaryTypographyProps={{
                                                  variant: "body2",
                                                  fontWeight:
                                                    selectedMenu === res?.label
                                                      ? 600
                                                      : 550,
                                                  fontSize: "0.8rem",
                                                  color:
                                                    selectedMenu === res?.label
                                                      ? "primary"
                                                      : grey[600],
                                                }}
                                                primary={res?.label}
                                                sx={{ margin: 0 }}
                                              />
                                            )}
                                          </ListItemButton>
                                        </ListItem>
                                      )}
                                    </List>
                                  </Link>
                                </Tooltip>
                              );
                            })}
                          </Collapse>
                        </>
                      )}
                      {atsInvoiceAccess && (
                        <Tooltip
                          key={"Invoice"}
                          title={"Manage Invoice"}
                          placement="right-end"
                        >
                          <Link to={"/ats/invoice"}>
                            <List sx={{ padding: "0px" }}>
                              <ListItem
                                key={"Invoice-item"}
                                disablePadding
                                data-testid="Invoice"
                                sx={{
                                  display: "block",
                                  fontSize: "12px",
                                  marginLeft: `${isMobile ? "-4px" : ""}`,
                                  pl: 0,
                                }}
                                onClick={(e) =>
                                  handleMenuClick("Invoice", "/ats/invoice")
                                }
                              >
                                <ListItemButton
                                  key={"Invoice-button"}
                                  selected={selectedMenu === "Invoice"}
                                  sx={{
                                    "&.Mui-selected": {
                                      backgroundColor:
                                        theme?.palette?.primary?.main + "20",
                                    },
                                    "&.Mui-selected:hover": {
                                      backgroundColor: "rgb(254 255 187 / 48%)",
                                    },
                                    ":hover": {
                                      backgroundColor: "rgb(254 255 187 / 48%)",
                                    },
                                    borderRadius: "8px",
                                    fontWeight: 600,
                                    minHeight: 44,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: open
                                      ? "flex-start"
                                      : "center",
                                    gap: open ? 2 : 0,
                                    padding: open ? "8px 12px" : "8px",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "24px",
                                      height: "24px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color:
                                          selectedMenu === "Invoice"
                                            ? theme?.palette?.primary?.main
                                            : theme.palette.mode === "dark"
                                            ? theme.palette.text.primary
                                            : theme.palette.text.secondary,
                                        transition: "color 0.3s ease",
                                      }}
                                    >
                                      <ReceiptIcon fontSize="small" />
                                    </span>
                                  </Box>
                                  {open && (
                                    <ListItemText
                                      key={"Invoice-text"}
                                      primaryTypographyProps={{
                                        variant: "body2",
                                        fontWeight:
                                          selectedMenu === "Invoice"
                                            ? 600
                                            : 550,
                                        fontSize: "0.8rem",
                                        color:
                                          selectedMenu === "Invoice"
                                            ? "primary"
                                            : grey[600],
                                      }}
                                      primary={"Invoice"}
                                      sx={{ margin: 0 }}
                                    />
                                  )}
                                </ListItemButton>
                              </ListItem>
                            </List>
                          </Link>
                        </Tooltip>
                      )}
                      {AtsUser && ['cvtmeepl', 'xpohrmeepl', 'adobemeepl'].includes(getDomain()) && (
                        <Tooltip
                          key={"Agreements"}
                          title={"Manage Agreements"}
                          placement="right-end"
                        >
                          <Link to={"/ats/agreements"}>
                            <List sx={{ padding: "0px" }}>
                              <ListItem
                                key={"Agreements-item"}
                                disablePadding
                                data-testid="Agreements"
                                sx={{
                                  display: "block",
                                  fontSize: "12px",
                                  marginLeft: `${isMobile ? "-4px" : ""}`,
                                  pl: 0,
                                }}
                                onClick={(e) =>
                                  handleMenuClick("Agreements", "/ats/agreements")
                                }
                              >
                                <ListItemButton
                                  key={"Agreements-button"}
                                  selected={selectedMenu === "Agreements"}
                                  sx={{
                                    "&.Mui-selected": {
                                      backgroundColor:
                                        theme?.palette?.primary?.main + "20",
                                    },
                                    "&.Mui-selected:hover": {
                                      backgroundColor: "rgb(254 255 187 / 48%)",
                                    },
                                    ":hover": {
                                      backgroundColor: "rgb(254 255 187 / 48%)",
                                    },
                                    borderRadius: "8px",
                                    fontWeight: 600,
                                    minHeight: 48,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: open
                                      ? "flex-start"
                                      : "center",
                                    gap: open ? 2 : 0,
                                    padding: open ? "8px 12px" : "8px",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "24px",
                                      height: "24px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color:
                                          selectedMenu === "Agreements"
                                            ? theme?.palette?.primary?.main
                                            : theme.palette.mode === "dark"
                                              ? theme.palette.text.primary
                                              : theme.palette.text.secondary,
                                        transition: "color 0.3s ease",
                                      }}
                                    >
                                      <HandshakeOutlinedIcon fontSize="small" />
                                    </span>
                                  </Box>
                                  {open && (
                                    <ListItemText
                                      key={"Agreements-text"}
                                      primaryTypographyProps={{
                                        variant: "body2",
                                        fontWeight:
                                          selectedMenu === "Agreements"
                                            ? 600
                                            : 550,
                                        fontSize: "0.8rem",
                                        color:
                                          selectedMenu === "Agreements"
                                            ? "primary"
                                            : grey[600],
                                      }}
                                      primary={"Agreements"}
                                      sx={{ margin: 0 }}
                                    />
                                  )}
                                </ListItemButton>
                              </ListItem>
                            </List>
                          </Link>
                        </Tooltip>
                      )}
                      {
                        // !userInfo?.is_ats_user && access?.length > 0 && access?.find(res => res?.module === "Onboarding")?.submodules?.[0]?.permission !== "XXXX" &&
                        atsOnboardingAccess && (
                          <Link to="/onboarding">
                            <ListItem
                              key={"onboarding-item"}
                              disablePadding
                              sx={{
                                display: "block",
                                fontSize: "12px",
                                marginLeft: `${isMobile ? "-4px" : ""}`,
                                pl: 0,
                              }}
                              onClick={(e) =>
                                handleMenuClick(
                                  "Employee Onboarding",
                                  "/onboarding"
                                )
                              }
                            >
                              <ListItemButton
                                key={"onboarding-button"}
                                selected={
                                  selectedMenu === "Employee Onboarding"
                                }
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor:
                                      theme?.palette?.primary?.main + "20",
                                  },
                                  "&.Mui-selected:hover": {
                                    backgroundColor: "rgb(254 255 187 / 48%)",
                                  },
                                  ":hover": {
                                    backgroundColor: "rgb(254 255 187 / 48%)",
                                  },
                                  borderRadius: "8px",
                                  fontWeight: 600,
                                  minHeight: 44,
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: open
                                    ? "flex-start"
                                    : "center",
                                  gap: open ? 2 : 0,
                                  padding: open ? "8px 12px" : "8px",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "24px",
                                    height: "24px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color:
                                        selectedMenu === "Employee Onboarding"
                                          ? theme?.palette?.primary?.main
                                          : theme.palette.mode === "dark"
                                          ? theme.palette.text.primary
                                          : theme.palette.text.secondary,
                                      transition: "color 0.3s ease",
                                    }}
                                  >
                                    <PersonAddIcon fontSize="small" />
                                  </span>
                                </Box>
                                {open && (
                                  <ListItemText
                                    key={"onboarding-text"}
                                    primaryTypographyProps={{
                                      variant: "body2",
                                      fontWeight:
                                        selectedMenu === "Employee Onboarding"
                                          ? 600
                                          : 550,
                                      fontSize: "0.8rem",
                                      color:
                                        selectedMenu === "Employee Onboarding"
                                          ? "primary"
                                          : grey[600],
                                    }}
                                    primary="Employee Onboarding"
                                    sx={{ margin: 0 }}
                                  />
                                )}
                              </ListItemButton>
                            </ListItem>
                          </Link>
                        )
                      }
                    </Collapse>
                  </>
                </React.Fragment>
              );
            })}
          </List>
        </ListItem>
      </Collapse>
    </React.Fragment>
  );
}
